import { memoize } from './memoize';
import type { ISpeedyBundler } from '@speedy-js/speedy-types';

// recursive to find root compiler, only be used with child compiler
const findRootCompiler = (compiler: ISpeedyBundler): ISpeedyBundler => {
  let result = compiler;

  const helper = (currentCompiler: ISpeedyBundler) => {
    if (currentCompiler.isChild()) {
      // if current compiler is child compiler, it must have parent compiler
      const parent = currentCompiler.parent as ISpeedyBundler;

      helper(parent);
    } else {
      // get root
      result = currentCompiler;
    }
  };

  helper(compiler);

  return result;
};

const memoizedFindRootCompiler = memoize(findRootCompiler);

export { findRootCompiler, memoizedFindRootCompiler };
